const MIN_EMPLOYEE_VALUE = ["dev"].includes(import.meta.env.VITE_ENV) ? 0 : 5;
const PAY_SALARY = 1;
const MAX_RESPONSE_VALUE = 5;

export default function prepReportData(data) {
  const employeeEthnicities = [
    ...new Set(data.employees.map((emp) => emp.data.ethnicity)),
  ];
  const employeeGenders = [
    ...new Set(data.employees.map((emp) => emp.data.gender)),
  ];
  const employeeRaces = [
    ...new Set(data.employees.map((emp) => emp.data.race)),
  ];
  const employeeDepartments = [
    ...new Set(data.employees.map((emp) => emp.data.department_id)),
  ];
  const employeePositions = [
    ...new Set(data.employees.map((emp) => emp.data.company_position_id)),
  ];

  return {
    completion_percentage: data.completion_progress
      ? (data.completion_progress.complete /
          (data.completion_progress.incomplete +
            data.completion_progress.complete)) *
        100
      : 0,
    employees: data.employees.map((emp) => ({
      ...emp.data,
      salary: emp.data?.salary_in_pennies / 100,
      answers: emp.responses.map((r) => ({
        question_id: r.parent_id,
        response: scoreResponse(r),
        comment: r.respondant_comment || null,
      })),
    })),
    questions: data.questions,
    ethnicities: Object.keys(data.ethnicities || {})
      .map((r) => ({
        key: r,
        text: data.ethnicities[r],
        value: parseInt(r),
      }))
      .filter((f) => employeeEthnicities.includes(f.value)),
    genders: Object.keys(data.genders || {})
      .map((r) => ({
        key: r,
        text: data.genders[r],
        value: parseInt(r),
      }))
      .filter((f) => employeeGenders.includes(f.value)),
    races: Object.keys(data.races || {})
      .map((r) => ({
        key: r,
        text: data.races[r],
        value: parseInt(r),
      }))
      .filter((f) => employeeRaces.includes(f.value)),
    departments: data.departments
      .map((d, idx) => ({
        key: d.id,
        value: d.id || idx,
        text: d.name || "Unknown",
      }))
      .filter((f) => employeeDepartments.includes(f.value)),
    positions: data.company_positions
      .map((d) => ({
        key: d.id,
        value: d.id,
        text: d.name,
      }))
      .filter((f) => employeePositions.includes(f.value)),
    company: data.company || {},
    surveyName: data.survey_name,
  };
}

function scoreResponse(r) {
  if (r.response_a) {
    return 1;
  }

  if (r.response_b) {
    return 2;
  }

  if (r.response_c) {
    return 3;
  }

  if (r.response_d) {
    return 4;
  }

  if (r.response_e) {
    return MAX_RESPONSE_VALUE;
  }

  return null;
}
